import { V3Record } from 'data/helpers/V3Record.js'

export const AppCodeUse = V3Record('appCodeUse', {
  createdAt: null,
  expiresAt: null,
  appCodeId: null,
  apiUserId: null,
  requestedDetails: null
})
